import type { NavigationGuard } from 'vue-router';
import { AIM_OIDC_ENABLED } from '@/types';
import { TENANT } from '@/utils/helpers';

/**
 * This guard redirects the user to the universal login page when the path is '/' and when no tenant is specified
 * Eg. http://localhost:8080 will be redirected to http://localhost:8080/login
 *
 * When AIM_OIDC_ENABLED is set (no-subdomain deployments), no redirect is needed — the normal
 * unauthenticated flow takes over and welcome-back handles the OIDC redirect.
 */
export const handleUniversalLoginRedirection: NavigationGuard = async (to, from, next) => {
  if (!TENANT && !AIM_OIDC_ENABLED) {
    return next({ name: 'universal-login' });
  }

  return next();
};
